import(/* webpackMode: "eager" */ "/var/www/alligator/article-preview/app/error.tsx");
